var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/ticket"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ticket"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9997 8.33317C12.9997 7.41317 13.7463 6.6665 14.6663 6.6665V5.99984C14.6663 3.33317 13.9997 2.6665 11.333 2.6665H4.66634C1.99967 2.6665 1.33301 3.33317 1.33301 5.99984V6.33317C2.25301 6.33317 2.99967 7.07984 2.99967 7.99984C2.99967 8.91984 2.25301 9.6665 1.33301 9.6665V9.99984C1.33301 12.6665 1.99967 13.3332 4.66634 13.3332H11.333C13.9997 13.3332 14.6663 12.6665 14.6663 9.99984C13.7463 9.99984 12.9997 9.25317 12.9997 8.33317Z",
    stroke: "#FFAC39",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.66699 2.6665L6.66699 13.3332",
    stroke: "#FFAC39",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketIcon);
export default __webpack_public_path__ + "static/media/ticket-icon.97aa4d9fa0500280e397113d54e230d4.svg";
export { ForwardRef as ReactComponent };